module.exports = __webpack_public_path__ + "static/img/ls34.2f26043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls34.png
// module id = xbLm
// module chunks = 12